import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbKeySet;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIterable, AbIterableIterator, AbIterator } from "abweb/collection/AbIterable";
import { AbSet } from "abweb/collection/AbSet";
import { TypeUtils } from "abweb/utils/TypeUtils";
export class AbKeySet {
  constructor(items = [], _keyFunction = item => TypeUtils.itemToKey(item, undefined)) {
    _defineProperty(this, "_map", new Map());
    _defineProperty(this, "toSet", () => {
      return AbSet.from(this);
    });
    _defineProperty(this, "add", value => {
      this._map.set(TypeUtils.itemToKey(value, this.keyFunction), value);
      return this;
    });
    _defineProperty(this, "clear", () => {
      this._map.clear();
    });
    _defineProperty(this, "delete", value => {
      return this._map.delete(TypeUtils.itemToKey(value, this.keyFunction));
    });
    _defineProperty(this, "forEach", callbackfn => {
      this._map.forEach(value => callbackfn(value, value, this));
    });
    _defineProperty(this, "has", value => {
      return this._map.has(TypeUtils.itemToKey(value, this.keyFunction));
    });
    _defineProperty(this, Symbol.iterator, () => {
      return this.values();
    });
    _defineProperty(this, "entries", () => {
      return AbIterableIterator.from(this._map.values()).map(v => [v, v]);
    });
    _defineProperty(this, "keys", () => {
      return this.values();
    });
    _defineProperty(this, "values", () => {
      return AbIterableIterator.from(this._map.values());
    });
    _defineProperty(this, "map", (mapFunction, keyFunction) => {
      return AbKeySet.from(AbIterable.from(this.values()).map(mapFunction), keyFunction);
    });
    _defineProperty(this, "flatMap", (mapFunction, keyFunction) => {
      return AbKeySet.from(AbIterable.from(this.values()).flatMap(mapFunction), keyFunction);
    });
    _defineProperty(this, "filter", filterFunction => {
      return AbKeySet.from(AbIterable.from(this.values()).filter(filterFunction), this.keyFunction);
    });
    _defineProperty(this, "filterType", filterFunction => {
      return AbKeySet.from(AbIterable.from(this.values()).filterType(filterFunction), this.keyFunction);
    });
    _defineProperty(this, "union", other => {
      return AbKeySet.from(AbIterable.concat(this.values(), other), this.keyFunction);
    });
    _defineProperty(this, "difference", other => {
      const otherSet = AbKeySet.from(other, this.keyFunction);
      return this.filter(item => !otherSet.has(item));
    });
    _defineProperty(this, "intersect", other => {
      const otherSet = AbKeySet.from(other, this.keyFunction);
      return this.filter(item => otherSet.has(item));
    });
    _defineProperty(this, "every", predicate => {
      return AbIterable.every(this, predicate);
    });
    _defineProperty(this, "any", predicate => {
      return AbIterable.any(this, predicate);
    });
    _defineProperty(this, Symbol.toStringTag, "AbKeySet");
    this.keyFunction = _keyFunction;
    if (Symbol.iterator in items) {
      AbIterable.from(items).forEach(this.add);
    } else {
      AbIterator.forEach(items, this.add);
    }
  }
  get size() {
    return this._map.size;
  }
}
_AbKeySet = AbKeySet;
_defineProperty(AbKeySet, "from", (items = [], keyFunction = item => TypeUtils.itemToKey(item, undefined)) => new _AbKeySet(items, keyFunction));
//# sourceMappingURL=AbKeySet.js.map
